module.exports = __webpack_public_path__ + "img/apple.28d74c08.svg";